import React, { useMemo } from 'react'

import propTypes from 'prop-types'

const ProgressBar = ({ visualStep, maxSteps }) => {
  const progressBarElements = useMemo(
    () =>
      Array(maxSteps)
        .fill('')
        .map((_, i) => i + 1),
    []
  )

  return (
    <div className='match-maker-progress-bar-container'>
      <div className='match-maker-progress-bar'>
        {progressBarElements.map(el => (
          <span
            key={el}
            className={
              el <= visualStep
                ? 'match-maker-progress-bar__item match-maker-progress-bar__item--active'
                : 'match-maker-progress-bar__item'
            }
          />
        ))}
      </div>
      <span className='match-maker-progress-bar-indicator'>
        {visualStep}/{maxSteps}
      </span>
    </div>
  )
}

ProgressBar.propTypes = {
  visualStep: propTypes.number.isRequired,
  maxSteps: propTypes.number.isRequired
}

export { ProgressBar }
